const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export default currentTimeZone;
